/**
 * Represents EmailValidationError
 */
class EmailValidationError extends Error {
	message: string
	title: string

	/**
	 * @constructor
	 * @param {string} message - message
	 * @param {string} title - title
	 */
	constructor(message, title) {
		super(message);
		this.title = title;
	}
}

export default EmailValidationError;
